import { StateCreator } from "zustand";
import { ITenantSlice } from "../models";
import { sliceResetFns } from "store";

const initialState = {
  tenant: null,
};

export const createTenantSlice: StateCreator<
  ITenantSlice,
  [["zustand/devtools", never]],
  [],
  ITenantSlice
> = (set) => {
  sliceResetFns.add(() => set(initialState));
  return {
    ...initialState,
    setTenant: (tenant) =>
      set(() => ({
        tenant,
      })),
  };
};
